if (!customElements.get('card-gallery')) {
class CardGallery extends HTMLElement {
  constructor() {
    super();

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  get _insideHorizontalSlider() {
    return !!this.closest('.slider--tablet, .slider--tablet-up');
  }

  get _shouldDisable() {
    return this._insideHorizontalSlider && window.matchMedia('(max-width: 749px)').matches;
  }

  init() {
    const slider = this.querySelector('.card-gallery__slides');
    if (!slider) return;

    const productUrl = this.dataset.productUrl;

    if (this._shouldDisable) {
      this.classList.add('card-gallery--static');
      if (productUrl) {
        this.addEventListener('click', () => {
          window.location.href = productUrl;
        });
      }
      return;
    }

    this.flickity = new Flickity(slider, {
      accessibility: false,
      rightToLeft: theme.config.rtl,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: false,
      draggable: true,
      cellAlign: 'left',
      setGallerySize: false,
      on: {
        scroll: (progress) => {
          this.updateProgress(progress);
        },
        staticClick: () => {
          if (productUrl) {
            window.location.href = productUrl;
          }
        }
      }
    });

    this.ro = new ResizeObserver(() => {
      if (this.flickity) {
        this.flickity.resize();
      }
    });
    this.ro.observe(this);
  }

  updateProgress(progress) {
    const bar = this.querySelector('.card-gallery__progress');
    if (!bar || !this.flickity) return;
    const clamped = Math.max(0, Math.min(1, progress));
    const track = this.querySelector('.card-gallery__bar');
    if (!track) return;
    const trackWidth = track.offsetWidth;
    const slideCount = this.flickity.slides.length;
    if (slideCount < 1) return;
    const barWidth = trackWidth / slideCount;
    const maxOffset = trackWidth - barWidth;
    bar.style.width = barWidth + 'px';
    bar.style.transform = 'translateX(' + (clamped * maxOffset) + 'px)';
  }

  disconnectedCallback() {
    if (this.ro) {
      this.ro.disconnect();
    }
    if (this.flickity) {
      this.flickity.destroy();
    }
  }
}

customElements.define('card-gallery', CardGallery);
}
